import { render, staticRenderFns } from "./makeApproval.vue?vue&type=template&id=1f9ed85c"
import script from "./makeApproval.vue?vue&type=script&lang=js"
export * from "./makeApproval.vue?vue&type=script&lang=js"
import style0 from "./makeApproval.vue?vue&type=style&index=0&id=1f9ed85c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports